var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Heading',{attrs:{"msg":"My Profile"}}),_c('v-card',{staticClass:"pa-5 mx-auto",attrs:{"max-width":"800"}},[_c('Profile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }